import React, { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./siteRequirements.css";
import { Windows, Apple } from "react-bootstrap-icons";
import download from "../../../assets/img/site_requirements/download.svg";
import adobe from "../../../assets/img/site_requirements/adobe.svg";
import flash from "../../../assets/img/site_requirements/flash.svg";

import internet from "../../../assets/img/site_requirements/internet.svg";
import safari from "../../../assets/img/site_requirements/safari.svg";
import firefox from "../../../assets/img/site_requirements/firefox.svg";
import crome from "../../../assets/img/site_requirements/crome.svg";
// import adobe from "../../../assets/img/site_requirements/adobe.svg";
import quicktime from "../../../assets/img/site_requirements/quicktime.svg";
import adoveacrobat from "../../../assets/img/site_requirements/adoveacrobat.svg";

import software_settings from "../../../assets/img/site_requirements/software_settings.svg";
import browsers from "../../../assets/img/site_requirements/browsers.svg";

import computer_operator from "../../../assets/img/site_requirements/computer_operator.svg";
import box_pc from "../../../assets/img/site_requirements/box_pc.svg";
import box_apple from "../../../assets/img/site_requirements/box_apple.svg";

import screens from "../../../assets/img/site_requirements/screens.svg";
import plugins from "../../../assets/img/site_requirements/plugins.svg";
import cookies from "../../../assets/img/site_requirements/cookies.svg";
import box_internet from "../../../assets/img/site_requirements/box_internet.svg";
import box_firebox from "../../../assets/img/site_requirements/box_firebox.svg";
import box_safari from "../../../assets/img/site_requirements/box_safari.svg";

const browsersData = [
  { name: "Microsoft Internet Explorer", img: internet },
  { name: "Safari", img: safari },
  { name: "Firefox 2", img: firefox },
  { name: "Crome", img: crome },
];
const downloads = [
  {
    name: "Internet Explorer",
    img: internet,
    url: "http://windows.microsoft.com/en-us/internet-explorer/download-ie",
  },
  {
    name: "Adobe Flash player",
    img: adobe,
    url: "http://get.adobe.com/flashplayer/",
  },
  {
    name: "Quick Time",
    img: quicktime,
    url: "http://www.apple.com/quicktime/",
  },
  {
    name: "Mozilla Firefox",
    img: firefox,
    url: "http://www.mozilla.org/en-US/firefox/new/",
  },
  {
    name: "Adobe Acrobat Reader",
    img: adoveacrobat,
    url: "http://get.adobe.com/reader/",
  },
];

const sections = [
  {
    id: "Software-Tools-Tips",
    title: "Software, Tools, and Tips",
    img: software_settings,
    description: (
      <>
        <p>
          Our website uses technology to create a more user-friendly experience.
          The result is a smarter, more easily navigated site. We hope you enjoy
          UAIC.com and that you encounter no technical difficulties while
          visiting the site.
        </p>
      </>
    ),
  },
  {
    id: "Browsers",
    title: "Browsers:",
    img: browsers,
    description: (
      <>
        <p>
          Although our site supports many popular browsers, UAIC.com is best
          viewed on Microsoft Internet Explorer 7.x or higher. It can also be
          viewed on Safari, and Firefox 2 or higher. Certain content may require
          plug-ins to be installed. And we also recommend that your browser has
          the latest updates or service packs.
        </p>
        <div className="container py-4">
          <div className="row g-3">
            {browsersData.map((browser, idx) => (
              <div className="col-6 col-sm-4 col-md-3" key={idx}>
                <div
                  className="text-center p-3 rounded-4 shadow-sm h-100 border"
                  style={{
                    background: "linear-gradient(to bottom, #f8fbff, #ffffff)", // soft blue fade
                    borderColor: "#e1ecf7",
                  }}
                >
                  <img
                    src={browser.img}
                    alt={browser.name}
                    className="mb-2"
                    style={{ width: "40px", height: "40px" }}
                  />
                  <div className="fw-medium">{browser.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    ),
  },
  {
    id: "Operating-Systems",
    title: "Operating Systems:",
    img: computer_operator,
    description: (
      <>
        <p>
          UAIC.com is supported in Windows 2000, XP and Vista. It is also
          supported on Mac OS 9 and OSX Panther.
        </p>
        <div className="container">
          <div className="row" style={{ gap: "10px" }}>
            {/* PC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Windows className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_pc}
                    alt="PC Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    PC
                  </h5>
                </div>
                <p className="mb-2" style={{ color: "black" }}>
                  Windows 2000, XP and Vista
                </p>
                <div className="page-privacy">
                  <ul className="mb-0 ps-3">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Browsers: Microsoft Internet Explorer 6.x or later,
                      Mozilla Firefox 2.x or later, Safari 2.x or later
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Minimum Monitor Color Depth: 32-bit color depth
                      recommended
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Resolution: 1024x768
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      RAM: 128 MB RAM (256 MB recommended)
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      CPU: 800MHz CPU (1GHz recommended)
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Plug-ins: Flash 9, QuickTime 6, Acrobat Reader 7
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Minimum connection speed: 200K (300K Recommended)
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* MAC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Apple className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_apple}
                    alt="Apple Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    MAC
                  </h5>
                </div>
                <p className="mb-2" style={{ color: "black" }}>
                  Mac OS 9.x, Mac OSX (Panther)
                </p>
                <div className="page-privacy">
                  <ul className="mb-0 ps-3 text-muted">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Browsers: Mac OS9: IE 6.x / Mac OSX Panther: IE 6.x,
                      Safari 2.x, Firefox 2.x
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Minimum Monitor Color Depth: 32-bit color depth
                      recommended
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Resolution: 1024x768
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      RAM: 128 MB RAM (256 MB recommended)
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      CPU: 800MHz CPU (1GHz recommended)
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Plug-ins: Flash 9, QuickTime 6, Acrobat Reader 7
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Minimum connection speed: 200K (300K Recommended)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: "Screen-Resolution",
    title: "Screen Resolution",
    img: screens,
    description: (
      <>
        <p>
          We recommend configuring your monitor to 1024 x 768 for optimal
          viewing. Settings vary depending on the system you are using. To set
          your monitor, follow the instructions below.
        </p>
        <div className="container">
          <div className="row" style={{ gap: "10px" }}>
            {/* PC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Windows className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_pc}
                    alt="PC Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    PC
                  </h5>
                </div>

                <div className="page-privacy">
                  <ul className="mb-0 ps-3">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Go to the START menu, choose "Settings" and select
                      "Control Panel."
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Double-click DISPLAY and select "Settings."
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Drag the slide bar in the SCREEN area until the numbers
                      read 1024 x 768.
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Under COLORS, select "High Color" (32 bit) Click "OK."
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* MAC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Apple className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_apple}
                    alt="Apple Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    MAC
                  </h5>
                </div>
                <div className="page-privacy">
                  <ul className="mb-0 ps-3 text-muted ">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Under the "Apple" menu, select "Control Panels" and then
                      "Monitors."
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      On the Monitor setting, under "Colors," select "Thousands"
                      and 1024 x 768.
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      When provided the option, we recommend restarting your
                      computer with the new color settings.
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      For more detailed instructions, please consult the
                      documentation that came with your monitor.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: "Plug-Ins",
    title: "Plug-Ins",
    img: plugins,
    description: (
      <>
        <p>
          The UAIC site uses Flash to provide interactive content. If this and
          other applications are not already installed on your computer, we
          recommend downloading the following plug-ins.
        </p>

        <div className="container">
          <div className="row" style={{ gap: "10px" }}>
            {/* PC Card */}
            <div className="col-12 col-md-12">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  //   background: 'linear-gradient(to bottom, #f8fbff, #ffffff)',
                  background: "#f7f7f7",
                  border: "1px solid #e1ecf7",
                }}
              >
                <p>
                  <img
                    src={download}
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "5px",
                    }}
                    alt="download icon"
                  />

                  <strong>Download</strong>
                </p>

                <p style={{ marginBottom: "0.2rem" }}>
                  <img
                    src={adobe}
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "5px",
                    }}
                    alt="adobe icon"
                  />{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="http://get.adobe.com/reader/"
                  >
                    Adobe Acrobat Reader
                  </a>{" "}
                  to read PDF documents
                </p>
                <p style={{ marginBottom: "0.2rem" }}>
                  <img
                    src={flash}
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "5px",
                    }}
                    alt="flash-icon"
                  />{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="http://get.adobe.com/flashplayer/"
                  >
                    Adobe Flash PlayerFlashto
                  </a>{" "}
                  view animation graphics, demos & tutorials
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: "Cookies",
    title: "Cookies",
    img: cookies,
    description: (
      <>
        <p>
          Please set your Internet preferences to enable cookies. Cookies are
          small text files containing information that identifies returning
          visitors exclusively for the duration of their visit. The information
          provided by cookies helps us to tailor content specifically to your
          needs. Our strict security guidelines guarantee that no personal data
          is stored during this process. See our Privacy Policy for more
          information. To enable cookies, follow the instructions below.
        </p>
        <div className="container">
          <div className="row" style={{ gap: "10px" }}>
            {/* PC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Windows className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_internet}
                    alt="PC Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    Internet Explorer
                  </h5>
                </div>
                <div className="page-privacy">
                  <ul className="mb-0 ps-3">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Windows IE 6.x Browser:
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select Tools
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select Internet Options
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select the Privacy tab
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select Advanced
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Deselect override automatic cookie handling button
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click on the OK button at the bottom of the screen
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click OK to exit.
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select "Preferences..." from the "Explorer" menu
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click "Cookies" under the "Receiving Files" heading in the
                      scrolling pane
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      In the "When receiving cookies" pull-down menu, select
                      "Never ask"
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click "OK" button to close "Preferences" window.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* MAC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Apple className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_firebox}
                    alt="PC Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    Firefox
                  </h5>
                </div>
                <p className="mb-2" style={{ color: "black" }}>
                  Windows and Mac systems
                </p>
                <div className="page-privacy">
                  <ul className="mb-0 ps-3 text-muted">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select Tools &gt; Options (Windows) or Firefox &gt;
                      Preferences (Mac)
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click “Privacy” in the left pane
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Check “Allow sites to set cookies” under the “Cookies”
                      section
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click “OK” button to close “Preferences” window.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: "Javascript",
    title: "Javascript",
    img: browsers,
    description: (
      <>
        <p>
          To optimize use of this Website, please make sure that JavaScript is
          activated in your browser’s settings. We use this technology to best
          display the individual pages with different screen resolutions and for
          navigation. To enable JavaScript, follow the instructions below:
        </p>
        <div className="container">
          <div className="row" style={{ gap: "10px" }}>
            {/* PC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Windows className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_internet}
                    alt="PC Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    Internet Explorer
                  </h5>
                </div>
                <p style={{ color: "black" }}>Windows IE 6.x Browser</p>
                <div className="page-privacy">
                  <ul className="mb-0 ps-3">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select “Internet Options” from the “Tools” menu
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select the “Security” tab and click “Custom Level”
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Scroll down to the “Scripting” section and select “Enable”
                      under “Active Scripting”
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click OK and “Yes” at the prompt
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click OK to exit
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Close all browser windows and relaunch IE
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* MAC Card */}
            <div className="col-12 col-md-6">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                  border: "1px solid #e1ecf7",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* <Apple className="text-primary me-2 fs-4" /> */}
                  <img
                    src={box_safari}
                    alt="PC Icon"
                    className="text-primary me-2 fs-4"
                    style={{ width: "22px", height: "22px" }}
                  />
                  <h5
                    className="mb-0 fw-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    Safari
                  </h5>
                </div>

                <div className="page-privacy">
                  <ul className="mb-0 ps-3 text-muted">
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Select “Preferences...” from the “Explorer” menu
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click the arrow next to “Web Browser”
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Click “Web Content”
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                        display: "list-item",
                        color: "#000",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Under “Active Content” check “Enable Scripting”
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: "Downloads",
    title: "Downloads",
    img: download,
    description: (
      <>
        <div className="container py-4">
          <div className="row g-3">
            {downloads.map((browser, idx) => (
              <div className="col-6 col-sm-4 col-md-3" key={idx}>
                <div
                  className="p-3 rounded-4 shadow-sm h-100 border position-relative text-center"
                  style={{
                    background: "linear-gradient(to bottom, #f8fbff, #ffffff)",
                    borderColor: "#e1ecf7",
                  }}
                >
                  {/* Download icon in top-right */}
                  <a
                    style={{ cursor: "pointer" }}
                    target="_blank"
                    href={browser.url}
                    rel="noreferrer"
                  >
                    <img
                      src={download}
                      alt="Download"
                      className="position-absolute"
                      style={{
                        top: "0.5rem",
                        right: "0.5rem",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </a>

                  {/* Main browser icon */}
                  <img
                    src={browser.img}
                    alt={browser.name}
                    className="mb-2"
                    style={{ width: "40px", height: "40px" }}
                  />

                  <div className="fw-medium">{browser.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    ),
  },
];

const SiteRequirements = () => {
  const [activeId, setActiveId] = useState("collected-info");

  const scrollToSection = (id) => {
    setActiveId(id);
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-3 border-end py-4">
          <h5 className="custom-heading">What UAIC Offers</h5>

          <ul className="list-unstyled">
            {sections.map((section) => (
              <li
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`py-2 px-3 mb-1 ${
                  activeId === section.id
                    ? "border-left-2 fw-bold bg-light border-start border-primary text-dark"
                    : "text-secondary"
                }`}
                style={{ cursor: "pointer", borderLeftWidth: "5px" }}
              >
                {section.title}
              </li>
            ))}
          </ul>
        </div>

        {/* Main Content */}
        <div className="col-md-9 py-4">
          {sections.map((section) => (
            <>
              <section id={section.id} key={section.id} className="mb-3 mt-3">
                <h5 className="fw-semibold" style={{ paddingTop: "5px" }}>
                  <img
                    src={section.img}
                    alt={section.title}
                    className="text-primary me-2 fs-4"
                    style={{ width: "30px", height: "30px" }}
                  />
                  {section.title}
                </h5>
                {/* <div
                  className="text-muted mt-2"
                  dangerouslySetInnerHTML={{ __html: section.description }}
                ></div> */}
                <div className="text-muted mt-2">{section.description}</div>
              </section>
              <hr />
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SiteRequirements;
